import axios from "axios";
import ApiConfig from "./apiconfig";
import toast from "react-hot-toast";
export const postDataHandler = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "POST",
      url: ApiConfig[endPoint],
      data: data,
    });

    if (res.data.responseCode === 200) {
      toast.success(res.data.responseMessage);
      return res.data;
    } else {
      toast.error(res.data.responseMessage);
      return res;
    }
  } catch (error) {
    console.log(error);
    // toast.error(error?.response?.data?.responseMessage);
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};

export const uploadFileDataHandler = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "POST",
      url: ApiConfig[endPoint],
      data: data,
    });

    if (res.data.responseCode === 200) {
      return res.data;
    } else {
      toast.error(res.data.responseMessage);
      return res;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};

export const getDataHandlerWithToken = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "GET",
      url: ApiConfig[endPoint],
      headers: {
        token: localStorage.getItem("token"),
      },
      data: data,
    });
    if (res.data.responseCode === 200) {
      return res.data;
    } else {
      return res;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};
export const getDataHandlerWithTokenParams = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "GET",
      url: ApiConfig[endPoint],
      headers: {
        token: localStorage.getItem("token"),
      },
      params: data,
    });
    if (res.data.responseCode === 200) {
      return res;
    } else {
      return res;
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};

export const postDataHandlerWithToken = async (endPoint) => {
  try {
    const res = await axios({
      method: "POST",
      url: ApiConfig[endPoint],
      headers: {
        token: localStorage.getItem("token"),
      },
    });
    if (res.data.responseCode === 200) {
      return res.data;
    } else {
      return res;
    }
  } catch (error) {
    console.log(error);
  }
};
export const postDataHandlerWithoutToken = async (endPoint) => {
  try {
    const res = await axios({
      method: "POST",
      url: ApiConfig[endPoint],
    });
    if (res.data.responseCode === 200) {
      return res.data;
    } else {
      return res;
    }
  } catch (error) {
    console.log(error);
  }
};

export const postDataHandlerWithTokenData = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "POST",
      url: ApiConfig[endPoint],
      headers: {
        token: localStorage.getItem("token"),
      },
      data: data,
    });
    if (res.data.responseCode === 200) {
      return res;
    } else {
      return res;
    }
  } catch (error) {
    console.log(error);
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};

export const putDataHandler = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "PUT",
      url: ApiConfig[endPoint],
      // headers: {
      //   token: token,
      // },
      data: data,
    });
    if (res.data.responseCode === 200) {
      toast.success(res.data.responseMessage);
      return res.data;
    } else {
      return res;
    }
  } catch (error) {
    console.log(error);
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};
export const putDataHandlerWithToken = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "PUT",
      url: ApiConfig[endPoint],
      headers: {
        token: localStorage.getItem("token"),
      },
      data: data,
    });
    if (res.data.responseCode === 200) {
      // toast.success(res.data.responseMessage);
      return res.data;
    } else {
      return res;
    }
  } catch (error) {
    console.log(error);
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};

export const deleteDataHandler = async (endPoint, dataToSend) => {
  try {
    const res = await axios({
      method: "DELETE",
      url: ApiConfig[endPoint],
      headers: {
        token: window.localStorage.getItem("token"),
      },
      params: dataToSend,
    });
    if (res.data.responseCode === 200) {
      return res;
    } else {
      return res;
    }
  } catch (error) {
    console.log(error);
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};

export const patchDataHandler = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "PATCH",
      url: ApiConfig[endPoint],
      data: data,
    });
    if (res.data.responseCode === 200) {
      toast.success(res.data.responseMessage);
      return res.data;
    } else {
      // toast.error(res.data.responseMessage);
      return res;
    }
  } catch (error) {
    console.log(error);
    if (error.response) {
      return error.response;
    } else {
      toast.error(error.message);
      return error;
    }
  }
};
